module.exports = __webpack_public_path__ + "img/GASAG_solution_plus.04cdef90.png";